import * as types from '@/actions/types'

export function setOpen(bool) {
  return {
    type: types.MODAL_SET_OPEN,
    setOpen: bool,
  }
}

export function setImage(image) {
  return {
    type: types.MODAL_SET_IMAGE,
    setImage: image,
  }
}

export function setText(image) {
  return {
    type: types.MODAL_SET_TEXT,
    setText: image,
  }
}

export function setData(data) {
  return {
    type: types.MODAL_SET_DATA,
    setData: data,
  }
}
